import { useCallback } from "react";
import { EvergisDynamicLayer } from "@evergis/api";
import { Layer } from "@evergis/sgis";

export const useSGisLayerRedraw = (sgisLayer?: Layer | null) =>
  useCallback(() => {
    if (sgisLayer) {
      if (sgisLayer instanceof EvergisDynamicLayer) {
        (sgisLayer as EvergisDynamicLayer).forceUpdate();
      }
      sgisLayer.redraw();
    }
  }, [sgisLayer]);
